import { render, staticRenderFns } from "./Estoques.vue?vue&type=template&id=2a182a47&"
import script from "./Estoques.vue?vue&type=script&lang=js&"
export * from "./Estoques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports